document.addEventListener('DOMContentLoaded', function() {
  // Create SVG element
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("id", "wave-background");
  svg.style.cssText = "position: fixed; top: 0; left: 0; width: 100vh; width: 100dvw; height: 100vh; height: 100dvh; z-index: -9999; pointer-events: none; isolation: isolate;";

  // Set background on html element to prevent white showing through on mobile overscroll
  document.documentElement.style.backgroundColor = "#0a0a0a";
  document.body.style.backgroundColor = "transparent";

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("stroke", "rgba(179, 255, 0, 0.07)");
  path.setAttribute("stroke-width", "7");
  path.setAttribute("stroke-linecap", "round");
  path.setAttribute("fill", "none");


  svg.appendChild(path);
  document.body.insertBefore(svg, document.body.firstChild);

  // Cache dimensions to avoid forced reflow in animation loop
  let cachedWidth = window.innerWidth;
  let cachedHeight = window.innerHeight;
  let rowOffsets = [];

  // Pre-calculate row offsets
  function updateDimensions() {
    cachedWidth = window.innerWidth;
    cachedHeight = window.innerHeight;
    rowOffsets = [];
    for (let row = 0; row < 10; row++) {
      rowOffsets.push((cachedHeight / 10) * row);
    }
    // Rebuild xs array on resize
    xs = [];
    for (var i = 0; i <= cachedWidth; i++) {
      xs.push(i);
    }
  }

  // Update dimensions on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateDimensions, 150);
  });

  // Initial calculation
  let xs = [];
  for (var i = 0; i <= cachedWidth; i++) {
    xs.push(i);
  }
  updateDimensions();

  let t = 0;
  function animate() {
    // Create multiple waves stacked vertically
    // Using cached values instead of querying window dimensions
    let pathData = "";
    for (let row = 0; row < 10; row++) {
      let yOffset = rowOffsets[row];
      let wavePoints = xs.map(x => {
        let y = yOffset + 7 * Math.sin((x + t) / 10);
        return [x, y];
      });
      pathData += "M" + wavePoints.map(p => p[0] + "," + p[1]).join(" L") + " ";
    }

    path.setAttribute("d", pathData);

    t += 0.7;
    requestAnimationFrame(animate);
  }
  animate();
});
